/**
 * Affiche un montant boutique selon la langue : préfixe $ en anglais, suffixe € en français.
 * Les valeurs en base (commandes, Stripe) restent en euros ; seul le libellé UI change.
 */
export function formatDisplayPrice(amount, language) {
  const n = typeof amount === 'number' ? amount : parseFloat(String(amount).replace(',', '.'));
  if (Number.isNaN(n)) {
    return String(amount);
  }
  const rounded = Math.round(n * 100) / 100;
  const str =
    Math.abs(rounded - Math.trunc(rounded)) < 1e-9
      ? String(Math.trunc(rounded))
      : rounded.toFixed(2);
  const lang = (language || 'fr').split('-')[0];
  if (lang === 'en') {
    return `$${str}`;
  }
  return `${str}€`;
}
